import { createAsyncThunk } from '@reduxjs/toolkit'
import apiClient from '../../../services/axois'

export const getStudentDashboard = createAsyncThunk(
  'student/getStudentDashboard',
  async ({ studentId, startDate, endDate }) => {
    try {
      let url
      if (startDate) {
        url = `/student/${studentId}/timetable?startDate=${startDate}&&endDate=${endDate}`
      } else {
        url = `/student/${studentId}/timetable`
      }
      const response = await apiClient.get(url)
      return response?.data?.result
    } catch (error) {
      console.error('builder function error:', error)
      throw error
    }
  },
)

export const createPracticeExam = createAsyncThunk('student/createPracticeExam', async (data) => {
  try {
  
    const {courseModuleIds, courseModuleTopicIds, navigate} = data
  

    
    const response = await apiClient.post('/student/practice-exam', {courseModuleIds, courseModuleTopicIds})
    navigate('/student-practice')
    return response?.data?.result
  } catch (error) {
    console.error('builder function error:', error)
    data.navigate("/dashboard")
    throw error
  }
})
